<script setup lang="ts">
const carousels = [
  {
    title: 'Top-Up Saldo KA Kredit',
    description:
      'Buka menu Kredit > Beli Kredit di dashboard. Pilih nominal yang diinginkan.'
  },
  {
    title: 'Gunakan untuk Pembayaran Paket',
    description:
      'Pilih metode KA Kredit saat checkout pengiriman paket atau transaksi ROMS. Masukkan PIN transaksi untuk konfirmasi.'
  },
  {
    title: 'Pantau Transaksi Real Time',
    description:
      'Lihat semua aktivitas di tab Penggunaan Kredit. Cek saldo, user, dan waktu transaksi secara otomatis'
  }
]
</script>

<template>
  <div
    class="bg-surface-container-low dark:bg-surface-container-highest py-6 lg:py-16 relative overflow-hidden"
  >
    <UiBgSkewY />
    <UiContainer class="flex flex-col gap-6 lg:gap-11 relative z-10">
      <UiSectionTitle
        class="lg:text-center"
        title="3 Langkah Mudah Menggunakan KA Kredit"
      />
      <UiCarouselFeature
        :items="carousels"
        hide-nav-button
        class-content-wrapper="overflow-visible"
      />
    </UiContainer>
  </div>
</template>
